import { uiSurface } from "shared/ui/uiSurface"
import { LocationOn, Person } from "@mui/icons-material"
import {
  Avatar,
  Box,
  Paper,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material"
import dayjs from "dayjs"
import { FC } from "react"
import { OrderDetail } from "src/db/OrderDetail"
import { SkeletonWrapper } from "src/features/shared-module/components"
import { appConstants } from "src/features/shared-module/constants"
import { WorkflowService } from "../services"
import { OrderTraceability } from "src/db/OrderTraceability"
import { t } from "i18next"

export const OrderTraceabilityView: FC<{
  orderDetail?: OrderDetail
  isLoading: boolean
}> = ({ isLoading, orderDetail }) => {
  if (isLoading) {
    return <SkeletonOrderTraceability />
  }

  if (!orderDetail) {
    return <>Missing Order Detail</>
  }

  const traceabilities = orderDetail?.traceabilities?.length
    ? orderDetail?.traceabilities
    : defaultList

  const workflowService = new WorkflowService()

  const getIcon = (trace: OrderTraceability): string => {
    if (trace.event === "DAILY_TRANSFER") {
      return "retweet"
    } else if (
      trace.event === "NONE" &&
      trace.targetState === trace.sourceState
    ) {
      return "pen"
    }
    const event = workflowService.getEventByOrder(orderDetail, trace)
    console.log(event)

    return event ? (event.icon as string) : "pen"
  }

  const getEventLabel = (trace: OrderTraceability): string => {
    const oDetail = JSON.parse(JSON.stringify(orderDetail))
    oDetail["stateMachineWorkflow"] = "DELIVERY"
    const event = workflowService.getEventByOrder(oDetail, trace)
    console.log(event)
    return event?.labelKey || ""
  }

  return (
    <Stepper
      {...uiSurface("UI-DSP-027")}
      data-testid="order-traceability-stepper"
      orientation="vertical"
      sx={(theme) => ({
        "& .MuiStepConnector-root": {
          marginLeft: 2,
          "& .MuiStepConnector-line": {
            borderLeftWidth: 3,
            borderColor: theme.palette.secondary.light,
          },
        },
      })}
    >
      {traceabilities.map((traceability, index) => (
        <Step key={traceability.event + index}>
          <StepLabel
            sx={(theme) => ({
              "& .MuiStepLabel-label.Mui-active": {
                color: theme.palette.primary.main,
              },
            })}
            icon={
              <Avatar
                sx={(theme) => ({
                  backgroundColor: theme.palette.secondary.light,
                  color: theme.palette.secondary.main,
                  border: `1px solid ${theme.palette.secondary.main}`,
                })}
              >
                <Box
                  sx={(theme) => ({
                    fontSize: 24,
                  })}
                  className={`fa fa-${getIcon(traceability)}`}
                />
              </Avatar>
            }
            optional={
              <Typography variant="caption">
                {dayjs(traceability.dateTime).format(
                  appConstants.dateTimeFormat_hhmmA,
                )}
              </Typography>
            }
          >
            <Typography variant="h3">
              {t(getEventLabel(traceability))}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

const SkeletonOrderTraceability = () => {
  return (
    <Stepper
      orientation="vertical"
      sx={(theme) => ({
        ".MuiStepConnector-root .MuiStepConnector-line": {
          borderLeftWidth: 3,
          borderColor: theme.palette.secondary.light,
        },
      })}
    >
      {Array.from({ length: 5 }, (e, i) => i).map((e: number) => {
        return (
          <Step key={e}>
            <StepLabel
              sx={{
                marginBottom: 0.5,
              }}
              icon={
                <SkeletonWrapper
                  sxProps={{
                    borderRadius: 2,
                  }}
                  height={36}
                  width={30}
                />
              }
            >
              <Stack spacing={0.5}>
                <SkeletonWrapper height={18} width={180} />
                <SkeletonWrapper height={16} width={200} />
              </Stack>
            </StepLabel>
          </Step>
        )
      })}
    </Stepper>
  )
}

const defaultList: any[] = [
  {
    dateTime: "2025-06-03T00:00:00Z",
    event: "ORDER_SEND_BACK_READY_FOR_HAULAGE",
  },
  {
    dateTime: "2025-06-03T02:30:00Z",
    event: "Event Name",
  },
  {
    dateTime: "2025-06-03T05:45:00Z",
    event: "Event Name",
  },
  {
    dateTime: "2025-06-03T08:15:00Z",
    event: "Event Name",
  },
  {
    dateTime: "2025-06-03T10:00:00Z",
    event: "Event Name",
  },
]
